import styled from "styled-components";

export const MaisDiv = styled.div`
  margin-top: 10px;
  color: #213f9a;
  .row {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon {
    background-color: #93d271;
  }
`;
